import React, { useState, useEffect, useContext } from "react";
import languageContext from "../context/language/languageContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const LabDashboard = () => {
  const [testRequests, setTestRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const {
    setSessionTimeout,
    setAlert,
    setMessage,
  } = useContext(languageContext);

  const sampleData = [
    {
      id: 1,
      patient_number: "P123456",
      uid: "UID7890",
      test_name: "Complete Blood Count",
      at_home: true,
      date: "2025-05-30"
    },
    {
      id: 2,
      patient_number: "P654321",
      uid: "UID5678",
      test_name: "Lipid Profile",
      at_home: false,
      date: "2025-06-02"
    },
    {
      id: 3,
      patient_number: "P111222",
      uid: "UID3344",
      test_name: "COVID-19 PCR",
      at_home: true,
      date: "2025-06-01"
    },
    {
      id: 4,
      patient_number: "P999888",
      uid: "UID2233",
      test_name: "Liver Function Test",
      at_home: false,
      date: "2025-06-05"
    },
    {
      id: 5,
      patient_number: "P444555",
      uid: "UID1122",
      test_name: "Urine Culture",
      at_home: true,
      date: "2025-06-03"
    }
  ];
  

  const navigate = useNavigate();

  const getTestRequests = async () => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/lab_request",
        {},
        { headers: headersList }
      );
      if (response.status === 200) {
        setTestRequests(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const getTestRequestsSearch = async (value) => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/lab_request",
        { search: value },
        { headers: headersList }
      );
      if (response.status === 200) {
        setTestRequests(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response?.data?.detail === "Token has expired") {
      setSessionTimeout(true);
    } else {
      console.error("Error Details:", error.message);
      setAlert(true);
      setMessage("Please try again later, something went wrong");
    }
  };

  useEffect(() => {
    const init = async () => {
      const currentPagePath = window.location.pathname;
      const loginBool = localStorage.getItem("login");
 
      if (loginBool === "true") {
        navigate("/lab_dashboard", { state: { url: currentPagePath } });
        await getTestRequests();
        // setTestRequests(sampleData)
      } else {
        navigate("/login", { state: { url: currentPagePath } });
      }
    };

    init();
  }, []);

  // Optional: debounce search
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getTestRequestsSearch(searchTerm.trim());
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  return (
    <div className="min-h-screen bg-gradient-to-r from-sky-50 to-blue-100 p-6">
      <h1 className="text-3xl font-bold text-blue-800 mb-6 text-center">
        Lab Dashboard – Test Requests Overview
      </h1>                                                         
      <div className="flex justify-center mb-8">
        <input
          type="text"
          placeholder="Search by patient number, UID, test name, or date"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full max-w-md px-4 py-2 rounded-lg border border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {testRequests.length === 0 ? (
          <div className="col-span-full text-center text-gray-600">
            No test requests found.
          </div>
        ) : (
          testRequests.map((request) => (
            <div
              key={request.id}
              className="bg-white rounded-2xl shadow-md border border-blue-200 p-5"
            >
              <h2 className="text-xl font-semibold text-blue-700 mb-2">
                {request.test_name}
              </h2>
              <p className="text-gray-600 text-sm">
                Patient Number: {request.patient_number}
              </p>
              <p className="text-gray-600 text-sm">
                UID: {request.uid}
              </p>
              <p className="text-gray-600 text-sm">
                Type: {request.at_home ? "At Home" : "Center"}
              </p>
              <p className="text-gray-600 text-sm">
                Date: {request.date}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LabDashboard;
